import { z as e } from "zod";
import { computed as t, readonly as n, ref as r, toRefs as i } from "vue";
import { defineStore as a } from "pinia";
//#region src/schemas/proposition.schema.ts
var o = e.union([
	e.literal("BOL"),
	e.literal("BPOST"),
	e.literal("CHEAP_CARGO"),
	e.literal("INSTABOX"),
	e.literal("DHL_EUROPLUS"),
	e.literal("DHL_FOR_YOU"),
	e.literal("DHL_PARCEL_CONNECT"),
	e.literal("DPD"),
	e.literal("GLS"),
	e.literal("POSTNL"),
	e.literal("UPS_EXPRESS_SAVER"),
	e.literal("UPS_STANDARD"),
	e.literal("TRUNKRS"),
	e.literal("BRT"),
	e.literal("INPOST"),
	e.literal("POSTE_ITALIANE")
]), s = e.union([
	e.literal("PACKAGE"),
	e.literal("MAILBOX"),
	e.literal("UNFRANKED"),
	e.literal("DIGITAL_STAMP"),
	e.literal("SMALL_PACKAGE"),
	e.literal("PALLET"),
	e.literal("LETTER")
]), c = e.union([
	e.literal("EVENING_DELIVERY"),
	e.literal("EXPRESS_DELIVERY"),
	e.literal("MORNING_DELIVERY"),
	e.literal("PICKUP_DELIVERY"),
	e.literal("PICKUP_EXPRESS_DELIVERY"),
	e.literal("SAME_DAY_DELIVERY"),
	e.literal("STANDARD_DELIVERY")
]), l = e.union([
	e.literal("AGE_CHECK"),
	e.literal("COLLECT"),
	e.literal("COOLED_DELIVERY"),
	e.literal("DROP_OFF_AT_POSTAL_POINT"),
	e.literal("EXTRA_ASSURANCE"),
	e.literal("HIDE_SENDER"),
	e.literal("LARGE_FORMAT"),
	e.literal("ONLY_RECIPIENT"),
	e.literal("RECEIPT_CODE"),
	e.literal("RETURN"),
	e.literal("SAME_DAY_DELIVERY"),
	e.literal("SATURDAY_DELIVERY"),
	e.literal("SIGNATURE"),
	e.literal("TRACKED")
]), u = e.union([
	e.literal("labelDescriptionLength"),
	e.literal("carrierSmallPackageContract"),
	e.literal("multiCollo"),
	e.literal("needsCustomerInfo")
]), d = e.union([
	e.literal("username"),
	e.literal("password"),
	e.literal("api_key"),
	e.literal("options.customerNumber"),
	e.literal("options.sendingDepot"),
	e.literal("options.departureDepot")
]), f = e.union([
	e.literal("discountContact"),
	e.literal("discountPrices"),
	e.literal("labelFee"),
	e.literal("labelFeePrice"),
	e.literal("sharpPricing")
]), p = e.union([
	e.literal("analytics"),
	e.literal("extraPerReturn"),
	e.literal("reasons"),
	e.literal("returnsPerMonth"),
	e.literal("rules")
]), m = e.union([
	e.literal("advancedAnalysis"),
	e.literal("avoidSurcharges"),
	e.literal("cases"),
	e.literal("claims"),
	e.literal("compareQuality"),
	e.literal("dailyReport"),
	e.literal("delays"),
	e.literal("deliveryPredictions"),
	e.literal("downloadGraphs"),
	e.literal("exportData"),
	e.literal("insightFinances"),
	e.literal("performanceBenchmark"),
	e.literal("shipmentLevel"),
	e.literal("surcharges"),
	e.literal("transitTime"),
	e.literal("volumePredictions"),
	e.literal("weekReport")
]), h = e.union([
	e.literal("bulkEdit"),
	e.literal("extraLabelFee"),
	e.literal("labelsIncludedPerMonth"),
	e.literal("returnRules"),
	e.literal("shipmentsIncludedPerMonth")
]), g = e.union([
	e.literal("automatedRules"),
	e.literal("divide"),
	e.literal("import"),
	e.literal("label"),
	e.literal("notes"),
	e.literal("picking"),
	e.literal("printCloud"),
	e.literal("printPickingLists")
]), _ = e.union([
	e.literal("browser"),
	e.literal("extraPrints"),
	e.literal("included"),
	e.literal("scanner")
]), v = e.strictObject({
	packageTypes: e.array(s),
	deliveryTypes: e.array(c),
	shipmentOptions: e.array(l),
	metadata: e.record(u, e.union([
		e.boolean(),
		e.number(),
		e.string()
	]))
}), y = e.discriminatedUnion("type", [e.strictObject({
	type: e.literal("dimensions"),
	value: e.number()
})]), b = e.strictObject({
	id: e.number().int().optional(),
	carrier: e.strictObject({
		id: e.number().int(),
		name: o
	}),
	configurationParameters: e.array(d).optional()
}), x = e.strictObject({
	type: e.union([e.literal("MAIN"), e.literal("CUSTOM")]),
	carrier: o
}), S = e.strictObject({
	language: e.string(),
	supportedLanguages: e.array(e.string()),
	timezone: e.string(),
	dateFormats: e.record(e.string(), e.string())
}), C = e.strictObject({
	documents: e.strictObject({
		termsAndConditionsUrl: e.string(),
		privacyStatementUrl: e.string(),
		cookieStatementUrl: e.string()
	}),
	faq: e.strictObject({
		postalCode: e.string(),
		directPrinting: e.string(),
		userManagement: e.strictObject({ roleExplanationUrl: e.string() })
	}),
	directPrinting: e.strictObject({ printApplicationDownloadUrls: e.strictObject({
		windows: e.string(),
		mac: e.string()
	}) }),
	manuals: e.strictObject({ myContracts: e.strictObject({
		DHL_FOR_YOU: e.string().optional(),
		DHL_PARCEL_CONNECT: e.string().optional(),
		DHL_EUROPLUS: e.string().optional(),
		DPD: e.string().optional(),
		UPS_STANDARD: e.string().optional(),
		UPS_EXPRESS_SAVER: e.string().optional(),
		GLS: e.string().optional(),
		BRT: e.string().optional(),
		TRUNKRS: e.string().optional(),
		INPOST: e.string().optional()
	}) }),
	finance: e.strictObject({
		carrierComparePriceUrl: e.string(),
		priceScalesPolicy: e.string(),
		tariffUrl: e.string()
	}),
	returns: e.string(),
	authenticators: e.record(e.string(), e.strictObject({
		name: e.string(),
		url: e.string()
	})),
	externalIntegrationSupportUrls: e.strictObject({
		amazon: e.string(),
		bol_dot_com: e.string(),
		etsy: e.string(),
		exact: e.string(),
		wix: e.string()
	}),
	orders: e.strictObject({ volumetricWeightLink: e.strictObject({
		UPS: e.string(),
		POSTNL: e.string()
	}) }),
	subscriptions: e.strictObject({
		comparePricesUrl: e.string(),
		compareFunctionalityUrl: e.string(),
		myAnalytics: e.strictObject({ moreInfoUrl: e.string() }),
		myContracts: e.strictObject({ moreInfoUrl: e.string() }),
		myOrders: e.strictObject({ moreInfoUrl: e.string() }),
		myScanAndPrint: e.strictObject({ moreInfoUrl: e.string() })
	}),
	termsAndConditions: e.strictObject({ dpd: e.string() })
}), w = e.discriminatedUnion("enabled", [e.strictObject({
	enabled: e.literal(!0),
	url: e.url()
}), e.strictObject({ enabled: e.literal(!1) })]), T = e.union([
	e.literal("transitTime"),
	e.literal("deliveryTo"),
	e.literal("handover"),
	e.literal("dimensions"),
	e.literal("weight"),
	e.literal("trackAndTrace"),
	e.literal("insurance"),
	e.literal("shipmentOptions"),
	e.literal("customDelivery"),
	e.literal("surcharge")
]), E = e.strictObject({
	proposition: e.strictObject({
		id: e.number().int(),
		key: e.string(),
		name: e.string(),
		shortName: e.string()
	}),
	contract: x,
	addressBook: e.strictObject({
		enableCollectAddress: e.boolean(),
		enableCreateReturnShipments: e.boolean()
	}),
	applications: e.strictObject({
		webshop: w,
		faq: w,
		developerPortal: e.discriminatedUnion("enabled", [e.strictObject({
			enabled: e.literal(!0),
			url: e.url(),
			pages: e.strictObject({ apiReference: e.url() })
		}), e.strictObject({ enabled: e.literal(!1) })]),
		corporate: w,
		backoffice: e.discriminatedUnion("enabled", [e.strictObject({
			enabled: e.literal(!0),
			url: e.url(),
			internationalization: S,
			workflow: e.union([e.literal("orders"), e.literal("shipments")])
		}), e.strictObject({ enabled: e.literal(!1) })]),
		consumerPortal: e.discriminatedUnion("enabled", [e.strictObject({
			enabled: e.literal(!0),
			url: e.url(),
			internationalization: S
		}), e.strictObject({ enabled: e.literal(!1) })])
	}),
	countryCode: e.string().length(2).toUpperCase(),
	centerOfCountry: e.strictObject({
		latitude: e.number(),
		longitude: e.number(),
		zoom: e.number()
	}),
	subscriptions: e.strictObject({
		bundle: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
			enabled: e.literal(!0),
			labelFeePrice: e.number(),
			usps: e.strictObject({
				start: e.array(f).optional(),
				plus: e.array(f).optional(),
				premium: e.array(f).optional(),
				max: e.array(f).optional()
			}).optional()
		})]),
		myAnalytics: e.strictObject({
			enabled: e.boolean(),
			availableDashboards: e.array(e.string()),
			usps: e.strictObject({
				start: e.array(m).optional(),
				plus: e.array(m).optional(),
				premium: e.array(m).optional(),
				max: e.array(m).optional()
			}).describe("USPs to hide show tier. Each string matches the last segment of an i18n key under `myAnalytics.usps.*`.")
		}),
		myContracts: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(h).optional(),
				plus: e.array(h).optional(),
				premium: e.array(h).optional(),
				max: e.array(h).optional()
			}).optional().describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myContracts.usps.*`.")
		}),
		myOrders: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(g).optional(),
				plus: e.array(g).optional(),
				premium: e.array(g).optional(),
				max: e.array(g).optional()
			}).describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myOrders.usps.*`.")
		}),
		myScanAndPrint: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(_).optional(),
				plus: e.array(_).optional(),
				premium: e.array(_).optional(),
				max: e.array(_).optional()
			}).optional().describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myScanAndPrint.usps.*`.")
		}),
		myReturns: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(p).optional(),
				plus: e.array(p).optional(),
				premium: e.array(p).optional(),
				max: e.array(p).optional()
			}).optional().describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myReturns.usps.*`.")
		}),
		orderRules: e.strictObject({ maxAmount: e.strictObject({
			default: e.number(),
			start: e.number(),
			plus: e.number()
		}) }),
		shippingRules: e.strictObject({
			countryCodes: e.array(e.string()),
			regionCodes: e.array(e.string()),
			maxAmount: e.number()
		}),
		showFooterText: e.boolean().optional()
	}),
	billing: e.strictObject({
		allowDisablingInvoiceEmails: e.boolean().describe("Whether the proposition allows shops to disable invoice emails from MyParcel. This does not indicate whether the feature is enabled for a shop, but whether it can be enabled or disabled."),
		sendsInvoiceEmailReminders: e.boolean().describe("Whether invoice reminders get sent trough email or the invoice itself."),
		paymentProvider: e.string(),
		bankMandate: e.strictObject({ cocRequired: e.boolean() }),
		hasVetting: e.boolean(),
		newInvoiceDates: e.strictObject({
			weekly: e.string(),
			monthly: e.string()
		}),
		invoiceFormats: e.array(e.enum([
			"CSV",
			"PDF",
			"UBL-XML"
		]))
	}),
	brackets: e.strictObject({
		weightTiers: e.partialRecord(o, e.array(e.strictObject({
			min: e.number().int(),
			max: e.number().int(),
			name: e.string()
		}))),
		availableForCarriers: e.array(o)
	}),
	collectTrip: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.discriminatedUnion("type", [e.strictObject({
		enabled: e.literal(!0),
		type: e.literal("internal")
	}), e.strictObject({
		enabled: e.literal(!0),
		type: e.literal("external"),
		url: e.url()
	})])]),
	contracts: e.strictObject({
		available: e.array(b.extend({
			hasCutoffTime: e.boolean(),
			hasPostponedDelivery: e.boolean(),
			inboundFeatures: v.optional(),
			outboundFeatures: v.optional(),
			surcharges: e.array(y.optional()).optional()
		})),
		availableForCustomCredentials: e.array(b),
		enablePostNLCustomContract: e.boolean(),
		inbound: e.record(e.string(), b).and(e.object({ default: b })),
		outbound: e.record(e.string(), b).and(e.object({ default: b }))
	}),
	companyDetails: e.strictObject({
		billing: e.strictObject({
			coc: e.string(),
			vatNumber: e.string()
		}),
		contact: e.strictObject({
			phoneNumber: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
				enabled: e.literal(!0),
				plain: e.string(),
				text: e.string(),
				openingHours: e.array(e.strictObject({
					name: e.string(),
					opens: e.string().optional(),
					closes: e.string().optional()
				}))
			})]),
			whatsapp: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
				enabled: e.literal(!0),
				url: e.url(),
				openingHours: e.array(e.strictObject({
					name: e.string(),
					opens: e.string().optional(),
					closes: e.string().optional()
				}))
			})])
		}),
		returnAddress: e.strictObject({
			countryCode: e.string(),
			company: e.string(),
			person: e.string(),
			postalCode: e.string(),
			houseNumber: e.string(),
			street: e.string(),
			city: e.string(),
			phone: e.string(),
			email: e.email()
		}),
		address: e.strictObject({
			countryCode: e.string(),
			company: e.string(),
			person: e.string(),
			postalCode: e.string(),
			houseNumber: e.string(),
			street: e.string(),
			city: e.string(),
			phone: e.string(),
			email: e.email()
		})
	}),
	assets: e.strictObject({
		url: e.url(),
		logo: e.strictObject({
			medium: e.strictObject({ url: e.url() }),
			small: e.strictObject({ url: e.url() })
		}),
		exampleDocuments: e.strictObject({
			products: e.strictObject({ csv: e.url() }),
			orders: e.strictObject({ csv: e.url() }),
			shipments: e.strictObject({ csv: e.url() }),
			addresses: e.record(e.string(), e.strictObject({ csv: e.url() }))
		})
	}),
	rules: e.strictObject({
		requiresEmailRecipient: e.boolean(),
		country: e.strictObject({
			withAddressFinder: e.array(e.string()),
			withPartnerLinks: e.array(e.string()),
			withPossibleReturn: e.array(e.string()),
			withRecommendedPhoneNumber: e.array(e.string()),
			withRequiredPhoneNumber: e.array(e.string()),
			withRequiredEmail: e.array(e.string()),
			withRequiredCompany: e.array(e.string()),
			withRequiredLabelDescription: e.array(e.string()),
			withRequiredHeight: e.array(e.string()),
			withRequiredLength: e.array(e.string()),
			withRequiredWidth: e.array(e.string()),
			withSeparatedStreetAndNumber: e.array(e.string())
		}),
		carrier: e.strictObject({
			withRecommendedPhoneNumber: e.array(e.string()),
			withRequiredPhoneNumber: e.array(e.string()),
			withRequiredEmail: e.array(e.string()),
			withRequiredCompany: e.array(e.string()),
			withRequiredLabelDescription: e.array(e.string()),
			withRequiredHeight: e.array(e.string()),
			withRequiredLength: e.array(e.string()),
			withRequiredWidth: e.array(e.string()),
			withRequiredWeight: e.array(e.string())
		})
	}),
	enableAcademy: e.boolean(),
	enablePrinterlessReturn: e.boolean(),
	enableLogoOnLabel: e.boolean(),
	enableShipmentEstimate: e.boolean(),
	enableCompanyDetailsEdit: e.boolean(),
	enableCompanyContactVatNumberNote: e.boolean(),
	enableContactChamberOfCommerce: e.boolean(),
	enableContactCompanyName: e.boolean(),
	enableContactVatNumber: e.boolean(),
	enableLocationFinder: e.boolean(),
	enableMyParcelAsReturnAddress: e.boolean(),
	enableFulfilment: e.boolean(),
	enableSalesChannels: e.boolean(),
	enableRetailLocations: e.boolean(),
	enableOptionToHideMyParcelLogo: e.boolean(),
	enableTellAFriend: e.boolean(),
	enableReturnContributions: e.array(s),
	enableLabelPackages: e.boolean(),
	enableEmailCenter: e.boolean(),
	enableRatesOverview: e.boolean(),
	support: e.strictObject({
		flow: e.union([e.literal("basic"), e.literal("advanced")]),
		availableTypes: e.array(e.strictObject({
			name: e.string(),
			id: e.number().int(),
			subTypes: e.array(e.string()).optional(),
			extraField: e.strictObject({
				name: e.string(),
				optional: e.boolean()
			}).optional()
		}))
	}),
	integrations: e.strictObject({ available: e.array(e.strictObject({
		id: e.number().int(),
		name: e.string(),
		hasAutoImport: e.boolean(),
		manualUrl: e.url().optional(),
		configurationParameters: e.array(e.strictObject({
			name: e.string(),
			human: e.string()
		})).optional()
	})) }),
	content: e.record(e.string(), C),
	weightCategories: e.record(e.string(), e.array(e.strictObject({
		median: e.number(),
		min: e.number(),
		max: e.number()
	}))),
	tools: e.strictObject({
		salesforce: e.strictObject({ enabled: e.boolean() }),
		googleTagManager: e.strictObject({
			enabled: e.boolean(),
			id: e.string(),
			url: e.url().or(e.literal(""))
		}),
		appcues: e.strictObject({
			enabled: e.boolean(),
			id: e.string(),
			enableLaunchpad: e.boolean()
		}),
		cookieConsent: e.strictObject({
			type: e.union([e.literal("cookiebot"), e.literal("oneTrust")]),
			enabled: e.boolean(),
			id: e.string()
		}),
		hotjar: e.strictObject({
			enabled: e.boolean(),
			id: e.string(),
			enableFeedbackModal: e.boolean()
		})
	}),
	browserExtension: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
		enabled: e.literal(!0),
		downloadUrl: e.strictObject({ chrome: e.url() })
	})]),
	deliveryOptions: e.strictObject({
		mondayDelivery: e.boolean(),
		dropOffDays: e.array(e.number().int())
	}),
	settings: e.strictObject({
		companyContact: e.strictObject({
			additionalProperties: e.array(e.string()),
			requiredProperties: e.array(e.string())
		}),
		export: e.strictObject({ availableProperties: e.array(e.union([
			e.literal("eori"),
			e.literal("voec"),
			e.literal("vatUk")
		])) }),
		enableIntegrations: e.boolean(),
		rules: e.strictObject({
			enableOrderRules: e.boolean(),
			enableReturnRules: e.boolean(),
			enableShipmentRules: e.boolean()
		}),
		shop: e.strictObject({ enableReturns: e.boolean() })
	}),
	orders: e.strictObject({ filters: e.strictObject({
		carriers: e.array(o),
		packageTypes: e.array(s),
		regionCodes: e.array(e.string())
	}) }),
	shipments: e.strictObject({
		enableInternational: e.boolean().describe("Whether the proposition allows for international shipments"),
		enableRegular: e.boolean(),
		enableCsvImport: e.boolean(),
		enablePallet: e.boolean(),
		enableReturn: e.boolean(),
		enableGoodsImportExport: e.boolean(),
		enableSocialShipping: e.boolean()
	}),
	rates: e.strictObject({ subjects: e.array(T) })
}), D = async (e) => {
	if (e === "myparcel-nederland") return (await import("./configs/myparcel-nederland.js")).default;
	if (e === "myparcel-belgie") return (await import("./configs/myparcel-belgie.js")).default;
	if (e === "myparcel-italie" || e === "myparcel-com") return (await import("./configs/myparcel-italie.js")).default;
}, O = {
	addressBook: {
		enableCollectAddress: !1,
		enableCreateReturnShipments: !1
	},
	applications: {
		backoffice: { enabled: !1 },
		webshop: { enabled: !1 },
		faq: { enabled: !1 },
		developerPortal: { enabled: !1 },
		corporate: { enabled: !1 },
		consumerPortal: { enabled: !1 }
	},
	collectTrip: { enabled: !1 },
	contract: {
		type: "MAIN",
		carrier: "POSTNL"
	},
	proposition: {
		id: 0,
		key: "",
		name: "",
		shortName: ""
	},
	countryCode: "",
	subscriptions: {
		bundle: { enabled: !1 },
		myAnalytics: {
			enabled: !1,
			availableDashboards: [],
			usps: {}
		},
		myContracts: { enabled: !1 },
		myOrders: {
			enabled: !1,
			usps: {}
		},
		myScanAndPrint: { enabled: !1 },
		myReturns: { enabled: !1 },
		orderRules: { maxAmount: {
			default: 0,
			start: 5,
			plus: 10
		} },
		shippingRules: {
			countryCodes: [],
			regionCodes: [],
			maxAmount: 0
		}
	},
	billing: {
		allowDisablingInvoiceEmails: !1,
		sendsInvoiceEmailReminders: !1,
		paymentProvider: "",
		bankMandate: { cocRequired: !1 },
		hasVetting: !1,
		newInvoiceDates: {
			weekly: "",
			monthly: ""
		},
		invoiceFormats: []
	},
	brackets: {
		availableForCarriers: [],
		weightTiers: {}
	},
	contracts: {
		available: [],
		availableForCustomCredentials: [],
		enablePostNLCustomContract: !1,
		inbound: { default: {} },
		outbound: { default: {} }
	},
	content: {},
	companyDetails: {
		billing: {
			coc: "",
			vatNumber: ""
		},
		contact: {
			phoneNumber: { enabled: !1 },
			whatsapp: { enabled: !1 }
		},
		address: {
			city: "",
			company: "",
			countryCode: "",
			email: "",
			houseNumber: "",
			person: "",
			phone: "",
			postalCode: "",
			street: ""
		},
		returnAddress: {
			city: "",
			company: "",
			countryCode: "",
			email: "",
			houseNumber: "",
			person: "",
			phone: "",
			postalCode: "",
			street: ""
		}
	},
	centerOfCountry: {
		latitude: 0,
		longitude: 0,
		zoom: 8
	},
	assets: {
		url: "",
		logo: {
			medium: { url: "" },
			small: { url: "" }
		},
		exampleDocuments: {
			products: { csv: "" },
			orders: { csv: "" },
			shipments: { csv: "" },
			addresses: { default: { csv: "" } }
		}
	},
	rules: {
		requiresEmailRecipient: !0,
		country: {
			withAddressFinder: [],
			withRecommendedPhoneNumber: [],
			withRequiredPhoneNumber: [],
			withRequiredEmail: [],
			withRequiredCompany: [],
			withRequiredLabelDescription: [],
			withRequiredHeight: [],
			withRequiredLength: [],
			withRequiredWidth: [],
			withPossibleReturn: [],
			withPartnerLinks: [],
			withSeparatedStreetAndNumber: []
		},
		carrier: {
			withRequiredPhoneNumber: [],
			withRequiredEmail: [],
			withRequiredCompany: [],
			withRecommendedPhoneNumber: [],
			withRequiredHeight: [],
			withRequiredLength: [],
			withRequiredWidth: [],
			withRequiredLabelDescription: [],
			withRequiredWeight: []
		}
	},
	enableAcademy: !1,
	enablePrinterlessReturn: !1,
	enableLogoOnLabel: !1,
	enableMyParcelAsReturnAddress: !1,
	enableOptionToHideMyParcelLogo: !1,
	enableShipmentEstimate: !1,
	enableCompanyDetailsEdit: !1,
	enableCompanyContactVatNumberNote: !1,
	enableContactChamberOfCommerce: !1,
	enableContactCompanyName: !1,
	enableContactSdi: !1,
	enableContactVatNumber: !1,
	enableVATSupport: !1,
	enableVATSupportNote: !1,
	enableSDISupport: !1,
	enableRetailLocations: !1,
	enableLocationFinder: !1,
	enableFulfilment: !1,
	enableTellAFriend: !1,
	enableReturnContributions: [],
	enableSalesChannels: !1,
	enableLabelPackages: !1,
	support: {
		flow: "basic",
		availableTypes: []
	},
	integrations: { available: [] },
	weightCategories: {},
	tools: {
		googleTagManager: {
			enabled: !1,
			id: "",
			url: ""
		},
		appcues: {
			enabled: !1,
			id: "",
			enableLaunchpad: !1
		},
		cookieConsent: {
			type: "cookiebot",
			enabled: !1,
			id: ""
		},
		hotjar: {
			enabled: !1,
			id: "",
			enableFeedbackModal: !1
		},
		salesforce: { enabled: !1 }
	},
	browserExtension: { enabled: !1 },
	deliveryOptions: {
		mondayDelivery: !1,
		dropOffDays: []
	},
	settings: {
		enableIntegrations: !1,
		companyContact: {
			additionalProperties: [],
			requiredProperties: []
		},
		export: { availableProperties: [] },
		rules: {
			enableOrderRules: !1,
			enableReturnRules: !1,
			enableShipmentRules: !1
		},
		shop: { enableReturns: !1 }
	},
	orders: { filters: {
		carriers: [],
		packageTypes: [],
		regionCodes: []
	} },
	shipments: {
		enableInternational: !1,
		enableRegular: !0,
		enableCsvImport: !0,
		enablePallet: !1,
		enableReturn: !0,
		enableGoodsImportExport: !1,
		enableSocialShipping: !0
	},
	rates: { subjects: [] }
}, k = a("propositionStore", () => {
	let e = r(O), n = t(() => e.value.support.flow === "advanced"), i = t(() => e.value.support.flow === "basic"), a = t(() => !!e.value.contracts.availableForCustomCredentials.find((e) => e.carrier.name === "BOL")), o = t(() => e.value.applications.backoffice.enabled && e.value.applications.backoffice.workflow === "orders");
	return {
		propositionConfig: e,
		hasAdvancedSupportFlow: n,
		hasBasicSupportFlow: i,
		hasBolAvailableAsCustomCredentials: a,
		availableContractsWithHandoverTime: t(() => e.value.contracts.available.filter(({ hasCutoffTime: e }) => e)),
		hasOrdersWorkflow: o,
		isMyParcelBe: t(() => e.value.proposition.key === "myparcel-belgie"),
		isMyParcelNl: t(() => e.value.proposition.key === "myparcel-nederland"),
		setProposition: (t) => {
			e.value = t;
		}
	};
}), A = () => {
	let e = k(), { propositionConfig: t, hasAdvancedSupportFlow: r, hasBasicSupportFlow: a, hasBolAvailableAsCustomCredentials: o, hasOrdersWorkflow: s, availableContractsWithHandoverTime: c, isMyParcelBe: l, isMyParcelNl: u } = i(e);
	return {
		proposition: n(t),
		hasAdvancedSupportFlow: r,
		hasBasicSupportFlow: a,
		hasBolAvailableAsCustomCredentials: o,
		hasOrdersWorkflow: s,
		availableContractsWithHandoverTime: c,
		isMyParcelBe: l,
		isMyParcelNl: u,
		setProposition: e.setProposition,
		getInboundContract: (e) => t.value.contracts.inbound[e] || t.value.contracts.inbound.default,
		getOutboundContract: (e) => t.value.contracts.outbound[e] || t.value.contracts.outbound.default,
		isCountryOfOrigin: (e) => t.value.countryCode === e,
		getIntegration: (e) => t.value.integrations.available.find((t) => t.name === e),
		getAvailableContractByCarrierName: (e) => t.value.contracts.available.find((t) => t.carrier.name === e)
	};
}, j = (e) => ({ install: () => {
	let { setProposition: t } = A();
	t(e);
} }), M = (e, t, n, r) => {
	let { proposition: i } = A();
	return n(i.value) ? !0 : r;
}, N = (e, t) => (n, r) => M(n, r, e, t);
//#endregion
export { w as ApplicationSchema, v as CarrierFeaturesSchema, o as CarrierNameSchema, C as ContentConfigSchema, d as ContractConfigurationParametersSchema, b as ContractSchema, x as DefaultContractSchema, c as DeliveryTypeSchema, S as InternationalizationSchema, u as MetadataKeySchema, s as PackageTypeSchema, E as PropositionConfigSchema, T as RatesSubjectSchema, l as ShipmentOptionSchema, y as SurchargeSchema, f as UspBundleSchema, m as UspMyAnalyticsSchema, h as UspMyContractsSchema, g as UspMyOrdersSchema, p as UspMyReturnsSchema, _ as UspMyScanAndPrintSchema, N as createPropositionGuard, j as createPropositionPlugin, D as getProposition, M as propositionGuard, A as useProposition };
